export const featureKey = 'genesysCloudEmailConversations';
